import React from "react";
import { Logo } from "./Logo";
import { MARLEA } from "@/constants/testIds";

export const Footer = () => {
  return (
    <footer
      data-testid={MARLEA.footer}
      className="relative border-t border-white/5 py-8"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between gap-6">
        <Logo size={26} />
        <div className="text-xs text-[#A7A7A7]">
          © {new Date().getFullYear()} Marlea AI
        </div>
      </div>
    </footer>
  );
};

export default Footer;
